import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

export function PageHeading() {
	return (
		<div className="space-y-2 pt-6 text-content-primary md:pt-10">
			<Text size="large" className="text-typography-weak">
				<Translate value="corgi.location_page_sitemap.page_heading.subtitle" />
			</Text>

			<Text as="h1" variant="heading" size="x-large" className="text-typography-strong">
				<Translate value="corgi.location_page_sitemap.page_heading.title" />
			</Text>
		</div>
	);
}
